module.exports = __webpack_public_path__ + "static/media/mesajussu-nasil-calisir.ef75f712.png";